import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Navigation from './Navigation';
import { ListItemSkeleton } from './skeletons';
import imgChoix from '../assets/img/Neo_bulle.png';
import { PoliceDefaut } from '../helpers/contants';
import '../styles/main.css';

export default function EventSelectionLanding({
  events,
  loading = false,
  navigationProps,
  onSelect,
  beforeNavigation,
  footer,
}) {
  return (
    <Container fluid>
      {beforeNavigation}
      <Row>
        <Navigation {...navigationProps} />
      </Row>
      {loading ? (
        <ListItemSkeleton count={5} />
      ) : (
        <>
          {events.length ? (
            <Row style={{ textAlign: 'center', width: '80%', margin: 'auto' }}>
              <img src={imgChoix} alt="" style={{ width: 400, margin: 'auto', marginTop: '2rem' }} />
            </Row>
          ) : (
            <Row
              style={{
                fontFamily: PoliceDefaut,
                margin: 'auto',
                width: 'fit-content',
                marginTop: '2%',
                textAlign: 'center',
                color: '#134491',
                fontSize: '150%',
              }}
            >
              Pas d'évènements disponibles
            </Row>
          )}

          <Row className="evenements" xs={events.length}>
            {events.map(event => (
              <Col key={event.id} sm={''} className="evenement mb-3">
                <NavLink onClick={() => onSelect(event)}>
                  <img src={event.photo} alt="Evenement" />
                </NavLink>
              </Col>
            ))}
          </Row>
          {footer}
        </>
      )}
    </Container>
  );
}
